export const routeLoaders = {
  dataManagement: () => import("src/pages/DataManagement"),
  settings: () => import("src/pages/Settings"),
  myInfo: () => import("src/pages/MyInfo"),
  createAccount: () => import("src/pages/CreateAccountPage"),
  admin: () => import("src/pages/AdminPage"),
  ppiRound1: () => import("src/pages/PPIInhibitorRound1"),
  ppiRound2: () => import("src/pages/PPIInhibitorRound2"),
  kinaseRound1: () => import("src/pages/KinaseInhibitorRound1"),
  kinaseRound2: () => import("src/pages/KinaseInhibitorRound2"),
  creditCharge: () => import("src/pages/CreditChargePage"),
  paymentHistory: () => import("src/pages/PaymentHistoryPage"),
  userBatchManagement: () => import("src/components/admin/UserBatchManagement"),
  preclinicalDrugResponse: () => import("src/pages/PreclinicalDrugResponsePage"),
  manual: () => import("src/pages/ManualPage"),
  creditListManagement: () => import("src/components/admin/CreditListManagement"),
  dashboardDetail: () => import("src/pages/DashboardDetailPage"),
  clinicalDrugResponse: () => import("src/pages/ClinicalDrugResponsePage"),
  drugToxicity: () => import("src/pages/DrugToxicityPage"),
  creditUserDetail: () => import("src/components/admin/CreditUserDetailListManagement"),
  policy: () => import("src/pages/PolicyPage"),
  contactUs: () => import("src/pages/ContactUsPage"),
  faq: () => import("src/pages/FaqPage"),
  mdtr: () => import("src/pages/MdtrPage"),
  animalToxicity: () => import("src/pages/AnimalToxicityPage"),
  biomarker: () => import("src/pages/BiomarkerPage"),
};

type RouteLoader = () => Promise<unknown>;

const isRoundOnePath = (pathname: string) => /\/round1(?:\/|$)/.test(pathname);

const getRouteLoader = (pathname: string): RouteLoader | undefined => {
  if (pathname === "/datamanagement") return routeLoaders.dataManagement;
  if (pathname === "/settings") return routeLoaders.settings;
  if (pathname === "/myinfo") return routeLoaders.myInfo;
  if (pathname === "/create-account") return routeLoaders.createAccount;
  if (pathname === "/admin-page") return routeLoaders.admin;
  if (pathname === "/batch-management") return routeLoaders.userBatchManagement;
  if (pathname === "/credit-management") return routeLoaders.creditListManagement;
  if (pathname.startsWith("/credit-management/user-detail/")) return routeLoaders.creditUserDetail;
  if (pathname === "/credit-charge-page") return routeLoaders.creditCharge;
  if (pathname === "/payment-history") return routeLoaders.paymentHistory;
  if (pathname === "/manual") return routeLoaders.manual;
  if (pathname === "/dashboard/detail") return routeLoaders.dashboardDetail;
  if (pathname === "/terms-of-service" || pathname === "/privacy-policy") return routeLoaders.policy;
  if (pathname === "/contact-us") return routeLoaders.contactUs;
  if (pathname === "/faq") return routeLoaders.faq;
  if (pathname.startsWith("/drug-response/preclinical/")) return routeLoaders.preclinicalDrugResponse;
  if (pathname.startsWith("/drug-response/clinical/")) return routeLoaders.clinicalDrugResponse;
  if (pathname.startsWith("/biomarker/")) return routeLoaders.biomarker;
  if (pathname.startsWith("/drug-toxicity/animal/")) return routeLoaders.animalToxicity;
  if (pathname.startsWith("/drug-toxicity/mdtr/") || pathname.startsWith("/mdtr/")) return routeLoaders.mdtr;
  if (pathname.startsWith("/drug-toxicity/")) return routeLoaders.drugToxicity;
  if (pathname.startsWith("/ppi-inhibitor/")) {
    return isRoundOnePath(pathname) ? routeLoaders.ppiRound1 : routeLoaders.ppiRound2;
  }
  if (pathname.startsWith("/kinase-inhibitor/")) {
    return isRoundOnePath(pathname) ? routeLoaders.kinaseRound1 : routeLoaders.kinaseRound2;
  }
  return undefined;
};

export const preloadRouteForPath = (pathname: string) => {
  const loader = getRouteLoader(pathname);
  if (!loader) return;
  void loader().catch(() => undefined);
};
